module.exports = __webpack_public_path__ + "static/media/man.107d9562.png";